import { Link } from "react-router-dom";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_somatic-growth-space/artifacts/jdlmeb42_CARL%20final%20selection_16%20%281%29.jpg";

const About = () => {
  return (
    <div data-testid="about-page">
      {/* Intro */}
      <section
        className="border-b"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg)",
        }}
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p
            className="text-sm md:text-base tracking-eyebrow uppercase mb-6"
            style={{ color: "var(--mc-muted)" }}
          >
            About
          </p>
          <h1
            className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.1] max-w-4xl"
            style={{ color: "var(--mc-ink)" }}
            data-testid="about-heading"
          >
            A compassionate, supportive therapeutic space — for whatever you’re
            carrying.
          </h1>
          <p
            className="mt-10 text-lg md:text-xl leading-relaxed max-w-3xl font-light"
            style={{ color: "var(--mc-ink-2)" }}
          >
            My approach integrates evidence-based therapeutic approaches with
            over fifteen years of contemplative, somatic, and mindfulness
            practice.
          </p>
        </div>
      </section>

      {/* Bio */}
      <section
        className="relative"
        style={{ backgroundColor: "var(--mc-bg-2)" }}
        data-testid="about-bio-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <div className="md:col-span-5">
            <div
              className="relative aspect-[4/5] overflow-hidden rounded-[2rem]"
              style={{ backgroundColor: "var(--mc-bg-3)" }}
              data-testid="about-photo"
            >
              <img
                src={ABOUT_IMG}
                alt="Carl Maxfield"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="md:col-span-7">
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-5"
              style={{ color: "var(--mc-muted)" }}
            >
              Hi, I'm Carl
            </p>
            <h2
              className="font-serif-display text-3xl md:text-4xl leading-snug mb-8"
              style={{ color: "var(--mc-ink)" }}
            >
              A counsellor, therapist &amp; long-term practitioner of
              contemplative and somatic disciplines.
            </h2>
            <div
              className="space-y-6 text-base md:text-lg leading-relaxed font-light"
              style={{ color: "var(--mc-ink-2)" }}
            >
              <p>
                I have over fifteen years of experience exploring practices that
                support emotional wellbeing, embodiment, and inner development.
                My work draws on a holistic approach — integrating counselling
                with trauma-informed understanding, nervous system awareness,
                and mindfulness-based practices.
              </p>
              <p>
                I grew up in Australia and then spent most of my adult life
                living throughout South America and Asia. Since 2010, I’ve
                immersed myself in the study and practice of qigong, yoga,
                meditation, and extensive healing modalities — alongside
                extended periods living in nature and learning with Indigenous
                communities.
              </p>
              <p>
                I support meaningful, lasting change by helping people develop
                greater self-awareness, strengthen emotional regulation, and
                take practical steps that improve everyday life. My goal is to
                help people feel more resilient, more at ease in themselves, and
                in their relationships.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* I work with */}
      <section
        className="border-t"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg)",
        }}
        data-testid="about-issues-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase"
              style={{ color: "var(--mc-muted)" }}
            >
              I support people navigating
            </p>
          </div>
          <ul className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-5">
            {[
              "Anxiety",
              "Depression",
              "Emotional overwhelm",
              "Relationship difficulties",
              "Loss and grief",
              "Trauma",
              "Meaning, purpose, and life transitions",
              "Spiritual crisis and spiritual emergence",
              "Identity and belonging",
              "Mystery illness / health concerns",
              "Social and cultural pressures",
              "Addiction",
              "Integration before and after expanded states or psychedelic experiences",
              "Personal growth and self-discovery",
            ].map((item, i) => (
              <li
                key={item}
                className="flex gap-3 items-start text-base md:text-lg font-light"
                style={{ color: "var(--mc-ink-2)" }}
                data-testid={`about-issue-${i}`}
              >
                <span
                  className="mt-3 w-1.5 h-1.5 rounded-full shrink-0"
                  style={{ backgroundColor: "var(--mc-terracotta)" }}
                />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Qualifications + What to expect */}
      <section
        className="border-t"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg-2)",
        }}
        data-testid="about-quals-section"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-2 gap-14">
          <div>
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-5"
              style={{ color: "var(--mc-muted)" }}
            >
              Qualifications
            </p>
            <h3
              className="font-serif-display text-2xl md:text-3xl mb-8"
              style={{ color: "var(--mc-ink)" }}
            >
              Trained in counselling, somatics &amp; trauma-informed care.
            </h3>
            <ul
              className="space-y-4 text-base md:text-lg font-light"
              style={{ color: "var(--mc-ink-2)" }}
              data-testid="qualifications-list"
            >
              <li>— Diploma of Counselling (AIPC)</li>
              <li>
                — Integrative Somatic Trauma Therapy, The Embody Lab (USA)
              </li>
              <li>
                — Ongoing training in holistic therapies, somatic &amp;
                mindfulness-based approaches
              </li>
            </ul>
          </div>

          <div>
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-5"
              style={{ color: "var(--mc-muted)" }}
            >
              What to expect
            </p>
            <h3
              className="font-serif-display text-2xl md:text-3xl mb-8"
              style={{ color: "var(--mc-ink)" }}
            >
              60-minute online sessions via Zoom.
            </h3>
            <p
              className="text-base md:text-lg leading-relaxed font-light mb-6"
              style={{ color: "var(--mc-ink-2)" }}
            >
              Sessions are confidential, supportive, and tailored to your
              unique needs, goals, and circumstances.
            </p>
            <p
              className="text-base md:text-lg leading-relaxed font-light"
              style={{ color: "var(--mc-ink-2)" }}
            >
              Together, we explore practical tools alongside deeper
              self-understanding, helping you develop emotional awareness,
              resilience, and meaningful change at a pace that feels right for
              you.
            </p>
            <Link
              to="/contact"
              className="mt-10 inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-sm tracking-wide transition-colors duration-300"
              style={{ backgroundColor: "var(--mc-ink)", color: "var(--mc-bg)" }}
              data-testid="about-contact-cta"
            >
              Begin a Conversation
            </Link>
          </div>
        </div>
      </section>

      {/* Counselling & Therapy */}
      <section
        className="border-t"
        style={{
          borderColor: "rgba(201, 192, 171, 0.55)",
          backgroundColor: "var(--mc-bg)",
        }}
        data-testid="about-counselling-vs-therapy"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p
              className="text-sm md:text-base tracking-eyebrow uppercase mb-5"
              style={{ color: "var(--mc-muted)" }}
            >
              Counselling &amp; therapy
            </p>
            <h2
              className="font-serif-display text-2xl md:text-3xl leading-snug"
              style={{ color: "var(--mc-ink)" }}
            >
              Two words for essentially the same work.
            </h2>
          </div>
          <div
            className="md:col-span-8 space-y-6 text-base md:text-lg leading-relaxed font-light max-w-2xl"
            style={{ color: "var(--mc-ink-2)" }}
          >
            <p>
              People often ask about the difference between counselling and
              therapy. In reality, the two overlap far more than they differ.
              Both are about helping you better understand yourself, develop
              greater awareness and create meaningful change in your life.
            </p>
            <p>
              Sometimes that’s as simple as having space to talk openly, gain
              clarity and explore what’s happening. Other times it may involve
              slowing down and paying attention to what your body is
              communicating through emotions, sensations and patterns that may
              have been outside your awareness.
            </p>
            <p>
              Healing isn’t one-size-fits-all. Depending on what you’re
              experiencing and your capacity at the time, our work together may
              focus on practical strategies, deeper self-understanding, emotional
              processing or building new ways of responding to life’s
              challenges.
            </p>
            <p>
              My approach is flexible and tailored to you. Alongside
              evidence-based counselling, I draw from trauma-informed practice,
              parts work, polyvagal-informed approaches and body awareness where
              appropriate. Together, we’ll find an approach that feels safe,
              collaborative and suited to your individual needs.
            </p>
            <p>
              Whether you’re looking to navigate a difficult period, strengthen
              relationships, understand yourself more deeply or create lasting
              change, we’ll work at a pace that feels right for you.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
